export default "__VITE_ASSET__BroeFVmS__"